// extracted by mini-css-extract-plugin
export var cardHeader = "_if-0";
export var reorderHandle = "_if-3";
export var titleArea = "_if-1";
export var titleAreaWithHandle = "_if-2";